import { render } from "./nevsCard.vue?vue&type=template&id=4b675d00&scoped=true&ts=true"
import script from "./nevsCard.vue?vue&type=script&lang=ts"
export * from "./nevsCard.vue?vue&type=script&lang=ts"

import "./nevsCard.vue?vue&type=style&index=0&id=4b675d00&scoped=true&lang=less"
import "./nevsCard.vue?vue&type=style&index=1&id=4b675d00&lang=css"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b675d00"]])

export default __exports__